/*
 * Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
 */

import Vue from "./init";
import App from "./components/app.vue";
import router from "./routes";
import store from "./store";
import i18n from "./translations";
import { detectAndUpdateBody } from "./util/webp";

Vue.config.productionTip = false;

// const urlParams = new URLSearchParams(window.location.search);

// const i18n = new VueI18n({
//   locale: urlParams.get("lang") || localStorage.getItem("language") || "en", // set locale
//   messages: {
//     en: {
//       "about me": "about me",
//       "what i do": "what i do",
//       "contact me": "contact me",
//       "Switch language": "Switch language",
//       //about me section
//       Education: "Education",
//       "Master's degree": "Master's degree",
//       Paramedic: "Paramedic",
//       "Certified specialist": "Certified specialist",
//       "skiing instructor": "skiing instructor",
//       "Work experience": "Work experience",
//       "Race experience": "Race experience",
//       //contact me
//       Mobile: "Mobile",
//       //footer
//       "Scroll to top": "Scroll to top"
//     },
//     cs: {
//       "about me": "o mně",
//       "what i do": "co nabízím",
//       "contact me": "kontakty",
//       "Switch language": "Přepnout jazyk",
//       //about me section
//       Education: "Vzdělání",
//       "Master's degree": "Magisterské studium",
//       Paramedic: "Zdravotnický záchranář",
//       "Certified specialist": "Diplomovaný specialista",
//       "skiing instructor": "lyžařský instruktor",
//       "Work experience": "Praxe",
//       "Race experience": "Závody",
//       //contact me
//       Mobile: "Mobil",
//       //footer
//       "Scroll to top": "Na začátek"
//     }
//   }
// });

let vueInstance = new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  mounted: () => {
    document.dispatchEvent(new Event("x-app-rendered"));
  }
});

detectAndUpdateBody().then(webpSupported => {
  //store.commit("settings/setWebp", webpSupported);
  store.dispatch("settings/setWebpSupport", webpSupported);
  console.log(`Webp support ${webpSupported}`);
  vueInstance.$mount("#app", {});
});
